import Container from "../../../utils/Container";
import loginImage from "../../../assets/banner/login.jpg";
import DhoorbinOutline from "../../../assets/icons/dhoorbin-outline.svg";
import BangladeshFlag from "../../../assets/icons/bangladesh.svg";
import { FaFacebook, FaGoogle, FaPray } from "react-icons/fa";
import { Link, useNavigate } from "react-router";
import FacebookPopupLogin from "../../../components/website/FacebookPopupLogin";
import axiosInstance from "../../../axiosInstance";
import { useState } from "react";
import toast from "react-hot-toast";
import { loginApi } from "../../../api/website/auth/auth";
import { loginAdmin } from "../../../api/admin/authApi";
const AdminLogin = () => {
  const navigate = useNavigate();
  const [FormData, setFormData] = useState({
    identifier: "",
    password: "",
  });
  const [IsLoading, setIsLoading] = useState(false);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleLogin = async ({ accessToken, userID }) => {
    const res = await axiosInstance.post(
      "https://api.dhoorbin.com/auth/facebook",
      {
        accessToken,
        userID,
      },
    );
  };

  const handleSubmit = () => {
    if (FormData.identifier === "" || FormData.password === "") {
      toast.error("Please fill all the fields");
    } else {
      loginAdmin(FormData, navigate, setIsLoading);
    }
  };

  return (
    <Container>
      <div className="w-full h-screen flex justify-center items-center">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 p-0 lg:p-10">
          <div className="hidden lg:block w-full lg:w-[600px] h-[600px] overflow-hidden rounded-lg">
            <img
              className="w-full h-full object-cover"
              src={loginImage}
              alt=""
            />
          </div>
          <div className="flex flex-col items-center gap-y-3 p-0 lg:p-5">
            <div className="text-center py-8 relative">
              <p className="font-bold text-3xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                Welcome Admin!
              </p>
              <span className="text-sm text-black/50">
                Ready to checkout All!
              </span>
              <div className="absolute -top-14 lg:-top-24 left-1/2 transform -translate-x-1/2 w-[250px] lg:w-[280px] opacity-60">
                <img className="" src={DhoorbinOutline} alt="" />
              </div>
            </div>
            <div className="w-full px-5 space-y-2 lg:space-y-5">
              <div className="relative">
                <label htmlFor="phoneNumber" className="text-black/60 text-xs">
                  Phone Number
                </label>
                <input
                  type="text"
                  placeholder="Enter Phone Number"
                  className="border w-full px-12 py-3 rounded-md focus:outline-none"
                  value={FormData.identifier}
                  onChange={handleChange}
                  id="identifier"
                />
                <div className="absolute top-9 left-2 w-7 h-7 overflow-hidden rounded-lg bg-white">
                  <img
                    className="w-full h-full object-cover"
                    src={BangladeshFlag}
                    alt=""
                  />
                </div>
              </div>
              <div>
                <label htmlFor="password" className="text-black/60 text-xs">
                  Password
                </label>
                <input
                  type="password"
                  placeholder="Enter your password"
                  className="border w-full px-10 py-3 rounded-md focus:outline-none"
                  value={FormData.password}
                  onChange={handleChange}
                  id="password"
                />
                <div className="flex justify-end">
                  <Link to={"/authentication/forget-password"}>
                    <button className="text-xs text-[#153875]">
                      Forget password?
                    </button>
                  </Link>
                </div>
              </div>
              <div>
                <button
                  onClick={handleSubmit}
                  className="bg-[#153875] w-full py-3 rounded-lg text-white text-sm font-semibold scale-100 hover:scale-105 duration-300 active:scale-95"
                  disabled={IsLoading ? true : false}
                >
                  {IsLoading ? "Processing" : "Sign In"}
                </button>
              </div>
              {/* <div className="py-5 relative">
                <hr />
                <div className="absolute top-1/2 -translate-y-1/2 left-1/2 transform -translate-x-1/2 text-xs bg-[#ffffffb4] text-black/50 px-5 border py-0.5 rounded-md">
                  OR
                </div>
              </div>
              <div className="px-4">
                <FacebookPopupLogin />
              </div>
              <div className="px-4">
                <button className="w-full border py-3 rounded-lg scale-100 hover:scale-105 duration-300 active:scale-95">
                  <div className="flex justify-center items-center gap-x-4">
                    <FaGoogle className="text-[#ff002b] text-lg" />
                    <p className="text-black/80 text-sm">Login With Google</p>
                  </div>
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AdminLogin;
